const initScrollToTop = function () {
    const goUpContainer = document.querySelector('.goup');
    const goUpLink = document.querySelector('.go-up');


    if (!goUpContainer || !goUpLink) return;

    window.addEventListener('scroll', function () {
        if (window.scrollY > 150) {
            goUpContainer.classList.add('show');
        } else {
            goUpContainer.classList.remove('show');
        }
    });

    goUpLink.addEventListener('click', function (event) {
        event.preventDefault();

        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });
};

export default initScrollToTop;